"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Codes = void 0;
// eslint-disable-next-line no-shadow
var Codes;
(function (Codes) {
    Codes[Codes["handshake"] = 100] = "handshake";
    Codes[Codes["acknowledge"] = 101] = "acknowledge";
    Codes[Codes["wait"] = 103] = "wait";
    Codes[Codes["hello"] = 120] = "hello";
    Codes[Codes["oh_hi"] = 121] = "oh_hi";
    Codes[Codes["fetch_register"] = 200] = "fetch_register";
    Codes[Codes["reply_register"] = 201] = "reply_register";
    Codes[Codes["join"] = 210] = "join";
    Codes[Codes["notify_join"] = 211] = "notify_join";
    Codes[Codes["leave"] = 220] = "leave";
    Codes[Codes["notify_leave"] = 221] = "notify_leave";
    Codes[Codes["update_profile"] = 230] = "update_profile";
    Codes[Codes["notify_profile"] = 231] = "notify_profile";
    Codes[Codes["relay"] = 240] = "relay";
    Codes[Codes["notify_relay"] = 241] = "notify_relay";
    Codes[Codes["fetch_model"] = 300] = "fetch_model";
    Codes[Codes["reply_model"] = 301] = "reply_model";
    Codes[Codes["subscribe_model"] = 302] = "subscribe_model";
    Codes[Codes["reply_stack"] = 305] = "reply_stack";
    Codes[Codes["submit_tx"] = 310] = "submit_tx";
    Codes[Codes["reply_tx"] = 311] = "reply_tx";
    Codes[Codes["notify_tx"] = 313] = "notify_tx";
    Codes[Codes["subscribe_topic"] = 401] = "subscribe_topic";
    Codes[Codes["forget_topic"] = 402] = "forget_topic";
    Codes[Codes["notify_topic"] = 403] = "notify_topic";
    Codes[Codes["reset_topic"] = 404] = "reset_topic";
    Codes[Codes["patch_topic"] = 405] = "patch_topic";
    Codes[Codes["broadcast_topic"] = 406] = "broadcast_topic";
    Codes[Codes["subscribe_record_set"] = 510] = "subscribe_record_set";
    Codes[Codes["forget_record_set"] = 511] = "forget_record_set";
    Codes[Codes["patch_record"] = 520] = "patch_record";
    Codes[Codes["notify_record"] = 521] = "notify_record";
    Codes[Codes["debug"] = 888] = "debug";
    Codes[Codes["eject"] = 999] = "eject";
})(Codes || (exports.Codes = Codes = {}));
